export default "__VITE_ASSET__ab7942de__"